// eslint-disable-next-line import/prefer-default-export
export enum StatusEnum {
  ACTIVE,
  PENDING,
  CLOSED,
}
